import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./OtherServices.css"; // Import custom CSS for additional styling if needed
import { Link } from "react-router-dom";

const OtherServices = ({otherServices}) => {
  
  return (
    <section className="services-area-home-3 services-area other_services">
      <img
        src="data:image/jpeg;base64,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"
        alt="VRE"
        className="services-page-services-area-shep-1 blur-1"
      />
      <Container>
        <Row className="other_services_row" style={{alignItems:"center"}}>
          <Col xl={5} lg={5}>
            {otherServices.map((service, index) => (
              <div className="services-name wow bounceInUp">
                <h4 className="font-size-1-40"><mark>{service.heading}</mark></h4>
                <div className="services-info">
                  <p className="font-size-1-16">{service.para}</p>
                  <Link to={service.url}>
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.12109 16.3848L9.53109 14.9748L3.95109 9.38477L16.1211 9.38476L16.1211 7.38476L3.95109 7.38477L9.54109 1.80477L8.12109 0.384765L0.121093 8.38477L8.12109 16.3848Z"
                        fill="#CCDEFF"
                      ></path>
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </Col>
          <Col xl={5} lg={5}>
            <div className="services-banner">
              <div className="title">
                <div className="sub-title">
                  <p>OTHER SERVICES</p>
                </div>
                <div className="main-title">
                  <h3 className="split-collab split-collab">
                    <div>
                      come on, we will help you sell Your Music Worldwide & Get
                      Paid
                    </div>
                    {/* <span
                      className="absolute"
                      style={{ display: "inline-block", position: "relative" }}
                    >
                      <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOMAAAAXCAYAAAD5jfhDAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMSSURBVHgB7ZpRbtNAEIZn2zzwhm9Qc4IGCSHxBByBk8ANEDeAG3CEHgGekAAJ9wbJCXDfKrX1dn97xt5snapJ08Rx/k9KvbvZpInjLzM7GxFCyCBwQkbNLy953D8WycKHnsVjR7I4x6iaeZmsQHjuk7jvReayAuG1zNKx8BwlbvHYdTTvjbv7mH2EMu6Yf16yS73gTRQXCRMLkVzouTVc1PZrCDQmnEqq8prANmZfDGWQvqx0HGI/C/2XblH4bUMZH0Es0iQIYRKZQCrUc52e44+Jc+jSDBgIOZNOZkTlOSK2RWjI+xTR+GBkTNO1SZKapalaj1DWr+f5JakdORxcI+hMGmnnaOtYGa6vYtVIOxgZTZZ4TRMLUi2mZUzXyD4AGQtpIup5uD6L+0R9lIzL0jT0qy4tuyMOUzVCahnPrkS+WMpby2hSQSiLRj0yod/KxjSN7Bm4+DNNI62P6/hCg4MtRbbNj1dO3qPh/nj5FF7MZ2GEIodJXLDB8QKDSTU2803ml2swQoDamC9Bxjoour9evBCcdHwIpVbMZhh0PXtefftgoG8vLL3/RrZfOu/bV4xxS+6vkswnqhK3fVnsx/NPZEREhRoc57b2w83OX2hP42OYe/rAp58FGV+gMZFxMscfryfxSE+ciYT9Jds0HsuG8VDpK8ylW0AY813UsTl43K5SxwV0SYZbW2RxXbsu0oT2uQp7Ft5X+dpJgfduSz9IatFVOlGx1/nB/g8i438ZfopaRy7ffUPV31apXEPYuCWbJ65poK8RCO0sbUuXRu6auJL6E+24igpR00Cw6zQVEaxUycpYsJDSFUjrKBhZBwh8pdEWkanSdiQujruQtpYUgiLdDa+xaKupTyRjr2Ref4IEyZgekiFg0moqmUsTWafSCHsq28ka8WOB7+vIWIsWpCp0LVavySySUTIyNn77tiiDY75GkeZBQMav4fhR++nPeigaIfewRNS1Imq76Y8j12aEbAY4dd2ku7i9S6qovTghhGwNRNLjZptjqlH0rd71TQghhBBCCCGEEELIsLkFDRdCiQgjnNkAAAAASUVORK5CYII="
                        alt=""
                      />{" "}
                    </span> */}
                  </h3>
                </div>
              </div>
              <div className="services-banner-inner">
                <div className="hero-banner-img-inner vre-reveal-one services-img vre-reveal-one">
                  <img
                    src="https://digital-agency-sadul.netlify.app/assets/services-1-home-3-DSSfNwpo.png"
                    alt="VRE"
                    className="vre-reveal-image-one"
                  />
                </div>
                <div className="hero-banner-img-inner vre-reveal-one services-img vre-reveal-one">
                  <img
                    src="https://digital-agency-sadul.netlify.app/assets/services-2-home-3-D9H1X9ZU.png"
                    alt="VRE"
                    className="vre-reveal-image-one"
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default OtherServices;
